import { isActionOf } from 'typesafe-actions'
import { from, of } from 'rxjs'
import { catchError, exhaustMap, filter, mergeMap, switchMap } from 'rxjs/operators'
import { toast } from 'react-toastify'
import { AnyAction } from 'redux'
import { AxiosError } from 'axios'
import { RootEpic } from '../types'
import {
  canUpdateUserData,
  updateUserCommissionFeeRequest,
  updateUserCommissionFeeSuccess,
  updateUserCommissionFeeFailure,
  updateUserDetailsRequest,
  updateUserDetailsSuccess,
  updateUserDetailsFailure,
} from '../actions'

export const updateUserCommissionFeeEpic: RootEpic = (action$, state$, { updateUserCommissionFee }) =>
  action$.pipe(
    filter(isActionOf([updateUserCommissionFeeRequest])),
    switchMap(({ payload }) =>
      from(
        updateUserCommissionFee({
          token: state$.value.app.authToken as string,
          ...payload,
        }),
      ).pipe(
        mergeMap((response) => {
          const actions: Array<AnyAction> = []
          if (response.success) {
            toast.success(response.message)
            actions.push(canUpdateUserData(true))
          } else {
            toast.error(response.message)
          }
          actions.push(updateUserCommissionFeeSuccess(response))
          return of(...actions)
        }),
        catchError((error) => {
          let message = error?.response?.data?.message || error?.message || 'Failed to update client type.'

          if (Array.isArray(message)) message = message.join(', ')

          toast.error(message)
          return of(updateUserCommissionFeeFailure(message))
        }),
      ),
    ),
  )

export const updateUserDetailsEpic: RootEpic = (action$, state$, { updateUserDetails }) => {
  return action$.pipe(
    filter(isActionOf([updateUserDetailsRequest])),
    exhaustMap(({ payload }) =>
      from(
        updateUserDetails({
          token: state$.value.app.authToken as string,
          ...payload,
        }),
      ).pipe(
        mergeMap((response) => {
          const actions: Array<AnyAction> = []
          if (response.success) {
            toast.success(response.message)
            actions.push(canUpdateUserData(true))
          } else {
            toast.error(response.message)
          }
          actions.push(updateUserDetailsSuccess(response))
          return of(...actions)
        }),
        catchError((error: AxiosError) => {
          toast.error(error.response?.data.message || 'Failed to update user details.')
          return of(updateUserDetailsFailure(error))
        }),
      ),
    ),
  )
}

export default [updateUserCommissionFeeEpic, updateUserDetailsEpic]
